import { Capacitor } from "@capacitor/core"
import { type ReactNode, useEffect } from "react"
import { LoadingState } from "~/components/screens/StateScreen"
import NotFoundPage from "~/routes/not-found"
import {
	PublicSuggestionDetailPage,
	PublicSuggestionNewPage,
	PublicSuggestionsPage
} from "./public"

function NativeExternalSuggestionGate({ children }: { children?: ReactNode }) {
	const nativeApp = Capacitor.isNativePlatform()

	useEffect(() => {
		if (!nativeApp) return
		const openExternal = async () => {
			const { Browser } = await import("@capacitor/browser")
			await Browser.open({ url: window.location.href })
		}
		openExternal().catch((error) => {
			console.error("Failed to open suggestion board externally", error)
		})
	}, [nativeApp])

	if (nativeApp) return <LoadingState className="min-h-screen" />
	return children ?? <NotFoundPage />
}

export function PublicSuggestionsExternalRoute() {
	return (
		<NativeExternalSuggestionGate>
			<PublicSuggestionsPage />
		</NativeExternalSuggestionGate>
	)
}

export function PublicSuggestionNewExternalRoute() {
	return (
		<NativeExternalSuggestionGate>
			<PublicSuggestionNewPage />
		</NativeExternalSuggestionGate>
	)
}

export function PublicSuggestionDetailExternalRoute() {
	return (
		<NativeExternalSuggestionGate>
			<PublicSuggestionDetailPage />
		</NativeExternalSuggestionGate>
	)
}

export function PublicSuggestionIndexExternalRoute() {
	return <NativeExternalSuggestionGate />
}
